/* src/app/private/components/department/department-details/department-details.component.scss */
/*# sourceMappingURL=department-details.component.css.map */
